module.exports = __webpack_public_path__ + "img/vertical_3_4_8023.d5fb5580.png";